import { registerEnumType } from 'type-graphql'

export enum CloneProjectModeEnum {
  IndependentCopy = 'IndependentCopy',
  SubProject = 'SubProject',
}

registerEnumType(CloneProjectModeEnum, {
  name: 'CloneProjectModeEnum',
  description: 'How a project clone should be created — as an independent copy with a fresh code, or as a sub-project deriving its code from the source.',
})
